import {EpLayer} from "./layer";
import {devicesStyle, farDevicesStyle} from "../styles/devices";
import {Feature} from "ol";
import {Point} from "ol/geom";
import {fromLonLat} from "ol/proj";

export class EpDevicesLayer extends EpLayer {
    constructor(map) {
        super(map);
        this.style = devicesStyle;
        this.farStyle = farDevicesStyle;
        this.title = 'Urządzenia';
        this.name = 'devices';

        return this;
    }

    addToMapFromCoordinates(coordinates, options = {}) {
        options = {...{ resize: false }, ...options};

        let feature = new Feature({
            geometry: new Point(fromLonLat(coordinates.split(","))),
            zoomLimit: 13.5,
            name: options.name,
            type: 'device',
            device_type_id: options.device_type_id,
            changed: false
        });
        feature.setId('device-' + options.id);
        this.getSource().addFeature(feature);

        if(options.resize) {
            this.fitInView();
        }
    }

    addDevicesFromObject(devices, options = {}) {

        let zoom = this.map.getView().getZoom();
        for(let device of devices) {
            let feature = this.addFeature([device.longitude, device.latitude], {
                resize: options.resize ?? false,
                fields: {
                    zoomLimit: 13.5,
                    type: 'device',
                    id: device.id,
                    name: device.name,
                    device_type_id: device.device_type_id
                }
            });

            if(zoom < 13.5){
                feature.setStyle(farDevicesStyle);
            }

        }
    }
}
